import React, { FC } from "react";

// custom hook
import { useFetchTableData } from "../../../hooks/useFetchTableData";

// component 
import { ReserveBunchTable } from "./table/ReserveBunchTable";
import { LoadingComponent } from "../../../components/common/Loading";
import { ErrorComponent } from "../../../components/common/ErrorComponent";

// api
import { RBMyFarmerAPI } from "../../../../api/reserve-bunch/RBMyFarmerAPI";
const rbMyFarmer = new RBMyFarmerAPI();


//  Reserve Bunch Component Start

export const ReserveBunch: FC = () => {
  
  // reserve bunch farmer data fetch
  const [responce, loading, error] = useFetchTableData(
    rbMyFarmer.allReserveBunchMyFarmer,
    5,
    1,
    {}
  );

  const data = Array.isArray(responce?.data?.data) ? responce?.data?.data : [];

  if (loading) {
    return <LoadingComponent />;
  }

  if (error) {
    return <ErrorComponent message={error} />;
  }

  return (
    <div  className="mt-5">
      <ReserveBunchTable data={data} />
    </div>
  );
};
